// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#162334","menuText":"#bac5d4","menuActiveText":"#165dff"};